//import react

import React, { useEffect, useState } from "react";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

//import redux
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { taxTxnMultiTxnErrors } from "../../../../../redux/features/transactions/taxTransaction/taxTransactionApproval";

//import components
import ICONS from "../../../../../assets/Icons";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";

const TaxationMultiApprovalFailed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 3️⃣ useSelector
  const { tdsTransactionApproveError, tdsTransactionRejectError } = useSelector(
    (state) => state.tdsTransactionApproval,
  );

  // 2️⃣ useState
  const [ErrorPageData, setErrorPageData] = useState([]);

  // 4️⃣ Constants / Derived values
  const actionType =
    tdsTransactionRejectError && !tdsTransactionApproveError
      ? "reject"
      : tdsTransactionApproveError && !tdsTransactionRejectError
        ? "approve"
        : "reject";

  const findCommonNames = (arr1, arr2) => {
    if (!Array.isArray(arr2)) {
      return [];
    }

    const isStringArray = arr2.some((item) => typeof item === "string");

    if (isStringArray) return arr2;

    const arr2Map = new Map(arr2.map((item) => [item?.id, item?.errors]));

    return arr1
      ?.filter((item) => arr2Map.has(item.txn_id))
      ?.map((item) => ({
        ...item,
        errors: arr2Map.get(item.txn_id),
      }));
  };

  const filterErrorTxn = findCommonNames(
    ErrorPageData,
    [JSON.parse(sessionStorage.getItem("taxTxnDataError"))] || [],
  );

  // 5️⃣ Callback / Handler functions
  const buttonRows = [
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/tax_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const getTitle = () =>
    actionType === "reject"
      ? "Oops! Transactions rejection failed"
      : "Oops! Transactions approval failed";

  const getSubtitle = () => {
    const action = actionType === "reject" ? "rejection" : "approval";
    return `An error occurred with the following transactions, causing the ${action} of all the transaction to fail.`;
  };

  // 6️⃣ useEffect
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
      dispatch(taxTxnMultiTxnErrors());
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedTaxData"),
    );

    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.selectedSendTransactions);
    } else {
      setErrorPageData([]);
    }
  }, []);

  return (
    <>
      <div>
        <StatusContainer
          status="error"
          buttonRows={buttonRows}
          title={getTitle()}
          subtitle={getSubtitle()}
        >
          <TabsWeapperSection title="Error details">
            <>
              {Array.isArray(filterErrorTxn) &&
                filterErrorTxn?.map((val, i) => {
                  if (
                    typeof val === "string" &&
                    val.includes("No transactions found for transaction ids")
                  ) {
                    return (
                      <InfoCard
                        bgColor="var(--negative-card)"
                        key={i}
                        rows={[
                          {
                            leftTitle: val,
                            leftSubTitle: "Error message",
                          },
                        ]}
                      />
                    );
                  }
                  return (
                    <React.Fragment key={i}>
                      {val?.map((error, index) => (
                        <InfoCard
                          bgColor="var(--negative-card)"
                          key={index}
                          rows={[
                            {
                              leftTitle: error?.reason || error,
                              leftSubTitle: "Error message",
                            },
                          ]}
                        />
                      ))}
                    </React.Fragment>
                  );
                })}
            </>
          </TabsWeapperSection>
          <TabsWeapperSection title="Transaction Details">
            <>
              {Array.isArray(filterErrorTxn) &&
                filterErrorTxn.map((val, i) => {
                  if (typeof val === "string") return null;
                  return (
                    <InfoCard
                      key={val.txn_id || i}
                      bgColor="var(--negative-card)"
                      onClick={() =>
                        navigate(
                          `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${val?.txn_id}`,
                        )
                      }
                      hoverable="white"
                      rows={[
                        {
                          leftTitle: val.tds_account_name,
                          leftSubTitle: "Account name",
                          hasRight: true,
                          rightText: true,
                          rightTitle: (
                            <>
                              INR <FormatAmount price={val?.amount} />
                            </>
                          ),
                          rightTitleTextColor: "var(--text-primary)",
                          rightTextFontWeight: "semibold",
                          rightSubTitle: "Amount",
                          rightIcon: true,
                        },
                      ]}
                    />
                  );
                })}
            </>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default TaxationMultiApprovalFailed;
